import { Button } from 'antd';
import { styled } from 'styled-components';

export const StyledButton = styled(Button)`
  .anticon-spin {
    display: inline-flex;
  }
  height: unset;
  transition: all 0.3s ease-out;

  &:disabled {
    opacity: 0.25 !important;
  }

  /* Handle hover states */
  &.filled:hover:not(:disabled) {
    background-color: ${props => props.theme.colors.primary.main.hover} !important;
  }

  &.light-filled:hover:not(:disabled) {
    background-color: ${props =>
      props.theme.colors.primary.light.linearHover || '#bae7ff'} !important;
  }

  &.linear:hover:not(:disabled) {
    background-color: ${props =>
      props.theme.colors.primary.main.linearHover || 'rgba(0, 0, 0, 0.04)'} !important;
  }

  &.light-linear:hover:not(:disabled) {
    background-color: ${props =>
      props.theme.colors.primary.dark.linearHover || 'rgba(0, 0, 0, 0.04)'} !important;
    border-color: transparent !important;
  }

  &.text:hover:not(:disabled) {
    background-color: ${props =>
      props.theme.colors.primary.main.linearHover || 'rgba(0, 0, 0, 0.04)'} !important;
  }
`;
